const wrapper = document.getElementsByClassName("wrapper")[0]
const carouse = document.getElementsByClassName("carousel")[0]
const arrowBtns = document.querySelectorAll(".wrapper svg")
const firstCardW = carouse.querySelector(".card").offsetWidth
const carouseChildrens = [...carouse.children]

let isDraggin = false, startX, startScrollLeft, timeoutId
let cardPerView = Math.round(carouse.offsetWidth / firstCardW)

carouseChildrens.slice(-cardPerView).reverse().forEach(card =>{
    carouse.insertAdjacentHTML("afterbegin", card.outerHTML)
})
carouseChildrens.slice(0, cardPerView).forEach(card =>{
    carouse.insertAdjacentHTML("beforeend", card.outerHTML)
})

arrowBtns.forEach(btn =>{
    const moveCarousel = () => {
        carouse.scrollLeft += btn.id === "cfi" ? -firstCardW : firstCardW;
    };
    btn.addEventListener("click", moveCarousel);
    btn.addEventListener("touchstart", moveCarousel);
})

const dragStart = (e) => {
    isDraggin = true
    carouse.classList.add("dragging")
    startX = e.pageX
    startScrollLeft = carouse.scrollLeft
}

const dragging = (e) =>{
    if(!isDraggin) return
    carouse.scrollLeft = startScrollLeft - (e.pageX -startX)
}
const dragStop = () => {
    isDraggin = false
    carouse.classList.remove("dragging")
}
const autoPlay = () =>{
    if(window.innerWidth < 800) return
    timeoutId = setTimeout(()=>{ 
        carouse.scrollLeft += firstCardW 
    },2500)
} 
autoPlay()

const infiteScroll = () =>{
    if(carouse.scrollLeft === 0 ){
        carouse.classList.add("no-transition")
        carouse.scrollLeft =carouse.scrollWidth - (2*carouse.offsetWidth)
        carouse.classList.remove("no-transition")
    }else if(Math.ceil(carouse.scrollLeft) === carouse.scrollWidth - carouse.offsetWidth){
        carouse.classList.add("no-transition")
        carouse.scrollLeft = carouse.offsetWidth
        carouse.classList.remove("no-transition")
    }
    clearTimeout(timeoutId)
    if(!wrapper.matches(":hover")) autoPlay()
}

carouse.addEventListener("mousedown", dragStart)
carouse.addEventListener("mousemove", dragging)
document.addEventListener("mouseup", dragStop)
carouse.addEventListener("scroll", infiteScroll)
wrapper.addEventListener("mouseenter", ()=> clearTimeout(timeoutId))
carouse.addEventListener("mouseleave", autoPlay)